<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      @selectField="onSelectField"
    />

<!--    현장 개요-->
    <vs-row class="my-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 현장 개요</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">현장명</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.fieldInfo.field_name }}</p>
        <ml-input
          :readonly="true"
          v-else
          v-model="form.fieldInfo.field_name"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">현장주소</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.fieldInfo.address }}</p>
        <ml-input
          :readonly="true"
          v-else
          v-model="form.fieldInfo.address"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">공사규모</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.fieldInfo.work_scale }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.fieldInfo.work_scale"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">사업금액</div>
        <p v-if="isPrint" class=" print-input flex-1">
          {{ form.fieldInfo.deposit_amount }}
        </p>
        <comma-input
          :readonly="true"
          v-else
          v-model="form.fieldInfo.deposit_amount"
          class="w-full flex-1"
        ></comma-input>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">공정율</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.fieldInfo.system_rate }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.fieldInfo.system_rate"
          class="w-full flex-1"
        />
      </div>
    </div>

<!--    재해발생 개요-->
    <vs-row class="mt-8">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 재해발생 개요</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">발생일시</div>
        <p v-if="isPrint" class=" print-input flex-1">
          {{ form.inputC_1 }}
        </p>
        <date-selector v-else :readonly="board.readonly" class="w-full flex-1" v-model="form.inputC_1" />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">시간(경)</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_2 }}</p>
        <time-selector v-else class="w-full flex-1" v-model="form.inputC_2" :readonly="board.readonly"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">재해자</div>
        <p  v-if="isPrint" class=" print-input flex-1">{{ name }}</p>
        <ml-input
          :readonly="board.readonly"
          v-else
          v-model="name"
          @focus="onNameFocus"
          @blur="onNameBlur"
          class="w-full flex-1"
        />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">상병명</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_4 }}</p>
        <ml-input
          v-else
          v-model="form.inputC_4"
          class="w-full flex-1"
          :readonly="board.readonly"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">상해정도</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_5 }}</p>
        <ml-input
          v-else
          v-model="form.inputC_5"
          class="w-full flex-1"
          :readonly="board.readonly"
        />
      </div>

      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">사고내용</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputC_6 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_6"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
    </div>

    <!--    재해관련 조치-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 재해관련 조치</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 mt-4">
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">초기대응</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputD_1 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputD_1"
          class="flex-1 w-full"
          rows="5"
        />
      </div>

      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 ">처리상태</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputD_2 }}</p>
        <ml-input
          v-else
          v-model="form.inputD_2"
          class="w-full flex-1"
          :readonly="board.readonly"
        />
      </div>
    </div>

    <!--    재해발생 원인-->
    <vs-row class="mt-8">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 재해발생 원인</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 mt-4">
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">재해발생 원인</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputD_3 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputD_3"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
    </div>

    <!--    재해발생 대책-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 재해발생 대책</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 mt-4">
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">물적 요인에 관한 대책</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputD_4 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputD_4"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">인적 요인에 관한 대책</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputD_5 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputD_5"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">관리적 요인에 관한 대책</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputD_6 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputD_6"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableInspectDivision from '@/components/TableInspectDivision'
import TableDuration from '../../../../components/TableDuration'
import TimeSelector from '@/components/selector/TimeSelector'

export default {
  components: {
    TimeSelector,
    TableDuration,
    TableInspectDivision,
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
        if (this.form.inputC_3 !== null && this.form.inputC_3 !== '') {
          this.name = this.form.inputC_3
          this.onNameBlur()
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    onSelectField(data) {
      console.log(data)
      this.form.fieldInfo.field_name = data.field_name;
      this.form.fieldInfo.address = data.address;
      this.form.fieldInfo.deposit_amount = data.deposit_amount;
    },
    onNameFocus () {
      this.name = this.form.inputC_3
    },
    onNameBlur () {
      this.form.inputC_3 = this.name
      const length = this.name.length
      if (2 < length) {
        const first = this.name[0]
        const last = this.name[this.name.length - 1]
        let star = ''
        for (let index = 0; index < length - 2; index++) {
          star += '*'
        }
        this.name = first + star + last
      } else if (length === 2) {
        const first = this.name[0]
        this.name = `${first  }*`
      }
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},
        fieldInfo: {
          field_name: "",
          address: "",
          work_scale: "",
          deposit_amount: "",
          system_rate: "",
        },

        inputC_1: '',
        inputC_2: '',
        inputC_3: '',
        inputC_4: '',
        inputC_5: '',
        inputC_6: '',

        inputD_1: '',
        inputD_2: '',
        inputD_3: '',
        inputD_4: '',
        inputD_5: '',
        inputD_6: '',

        fileList: [],
      },
      name: '',
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
